import React, { createContext } from "react";

import { noop } from "@/utils/functions";
import { ToastData } from "@/views/components/Toast/ToastsProvider";

export interface ToastsContextValue {
  addToast: (toast: Partial<ToastData>) => void;
}
export const ToastsContext = createContext<ToastsContextValue>({
  addToast: noop,
});

export interface WithToastsProps {
  toasts: ToastsContextValue;
}

export const ToastsConsumer = ToastsContext.Consumer;

export function withToasts<P extends WithToastsProps>(WrappedComponent: React.ComponentType<P>) {
  return class WithToasts extends React.Component<Omit<P, keyof WithToastsProps>> {
    renderContext = (toasts: ToastsContextValue) => {
      return <WrappedComponent {...(this.props as P)} toasts={toasts} />;
    };

    render() {
      return <ToastsConsumer>{this.renderContext}</ToastsConsumer>;
    }
  };
}
